import Vue from 'vue'

import router from './router'
// import 'babel-polyfill'
import promise from 'es6-promise'
import request from "./utils/request"
import params from './utils/params';
import './assets/css/style.css'
import App from './App.vue'

promise.polyfill()
Vue.config.productionTip = false
Vue.prototype.$params = params;
Vue.prototype.$request = request;
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
